import { RecipeArticle } from './RecipeArticle';

export type { TypeRecipeArticleProps } from './types';
export default RecipeArticle;
